import { render, staticRenderFns } from "./salesOverview.vue?vue&type=template&id=4ce4d161&scoped=true"
import script from "./salesOverview.vue?vue&type=script&lang=js"
export * from "./salesOverview.vue?vue&type=script&lang=js"
import style0 from "./salesOverview.vue?vue&type=style&index=0&id=4ce4d161&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ce4d161",
  null
  
)

export default component.exports